import React, { useState, useEffect, useReducer } from "react";
import moment from "moment";
import {
  Grid,
  Button,
  List,
  Box,
  TextField,
  SwipeableDrawer,
  FormControl,
  InputLabel,
  Typography,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  CardContent,
  Card,
  CardActions,
  Tooltip,
  Link,
  IconButton,
  CardMedia,
  TablePagination,
} from "@material-ui/core";
import PageTitle from "../../../components/PageTitle";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import useStyles from "../../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { MdRemoveRedEye, MdFileDownload } from "react-icons/md";
import { useLocation } from "react-router-dom";
import PaySlipImg from "../../../images/employee/paySlipCard.jpg";
import NoDataFound from "../../../components/NoDataFound/index.js";

function ViewAllEmployeePaySlip() {
  const classes = useStyles();

  const token = localStorage.getItem("token");

  const [loader, setLoader] = useState(false);
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const [payslipData, setPayslipdata] = useState([]);
  const location = useLocation();
  const employeeId = new URLSearchParams(location.search).get("id");
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);

  const handleFeedbackModalOpen = () => {
    setFeedbackModalOpen(true);
  };

  const handleFeedbackModalClose = () => {
    setFeedbackModalOpen(false);
  };

  useEffect(() => {
    fetchPayslipDetails();
  }, []);

  const fetchPayslipDetails = async () => {
    try {
      setLoader(true);
      axios({
        method: "get",
        url: `${process.env.REACT_APP_SERVER}payslip/getAllPayslips`,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        setLoader(false);
        if (response.data.status === true) {
          const responseData = response.data.data;
          setCount(response.data.count);
          setPayslipdata(responseData);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setLoader(true);
    setCurrentPage(newPage + 1);

    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}payslip/getAllPayslips?page=${currentPage}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setPayslipdata(response.data.data);
        setCount(response.data.count);
      }

      setLoader(false);
    });
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={5} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Pay Slip" />
        </Grid>
      </Grid>
      {payslipData.length === 0 && <NoDataFound height="80vh" message="No Data Found" />} 
      <Grid container spacing={2}>
        {payslipData.map((items) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={items}>
            <Card style={{ maxWidth: 345 }}>
              <CardMedia
                component="img"
                height="194"
                image={PaySlipImg}
                alt="Paella dish"
              />
              <CardContent>
                <p
                  style={{ fontSize: "20px", fontWeight: "500" }}
                >
                  This impressive paella is a perfect.
                </p>
              </CardContent>
              <CardActions disableSpacing>
                <IconButton aria-label="add to favorites">
                  <MdFileDownload />
                </IconButton>
                <IconButton aria-label="share">
                  <MdRemoveRedEye />
                </IconButton>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2} className={classes.pagination}>
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={count}
          rowsPerPage={10}
          page={page}
          onPageChange={handleChangePage}
        />
      </Grid>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default ViewAllEmployeePaySlip;
